import { createSlice } from '@reduxjs/toolkit'
import ProfileService from '../services/profile.service'
import { USERS } from '../utils/constants/actionTypes'
import createAsyncThunkMiddleware from '../utils/helpers/createAsyncThunkMiddleware'

/**
 */
export const getProfile = createAsyncThunkMiddleware(
  USERS.GET_PROFILE,
  ProfileService.getProfile,
)

/**
 * body - {...}
 */
export const updateProfile = createAsyncThunkMiddleware(
  USERS.UPDATE_PROFILE,
  ProfileService.updateProfile,
)

export const uploadImageProfile = createAsyncThunkMiddleware(
  USERS.UPDATE_PROFILE,
  ProfileService.uploadImgProfile,
)

const initialState = { resp: {} }

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.fulfilled, (state, action) => {
        return action.payload
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        return action.payload
      })
      .addCase(updateProfile.rejected, (state, action) => {
        return state
      })
  },
})

export default profileSlice.reducer
